// lib
import { css } from 'styled-components'

// Comps
import { colors, mobileScreen, fontWeights } from '../../utils'
import { backgroundImage, px_par } from '../../utils/styles'

export const previewEarningsCalculatorSectionStyles = css`
  position: relative;
  width: 100%;

  .content {
    /* WTH? double wrapper :( */
    display: flex;
    justify-content: center;
    align-items: center;

    ${mobileScreen(css`
      flex-direction: column;
    `)}
  }

  .half-background {
    position: absolute;
    right: 0px;
    top: 0px;
    bottom: 0px;
    width: 60%;
    background: ${colors.paleOrange};

    ${mobileScreen(css`
      width: 100%;
    `)}
  }

  .cell {
    position: relative;
    width: 100%;
    max-width: ${1000 / 2}px;

    ${mobileScreen(css`
      max-width: 100%;
    `)}
  }

  .left {
    box-sizing: border-box;
    position: relative;
    padding-top: 45px;
    padding-bottom: 45px;

    margin-right: ${px_par(500, 10)};

    ${mobileScreen(css`
      margin-right: unset;
      padding-bottom: unset;
    `)}

    .image-box {
      position: relative;
      width: 100%;
      padding-top: ${px_par(494, 389)};

      border-radius: 10px;
      overflow: hidden;

      img {
        ${backgroundImage}
      }
    }
  }

  .right {
    box-sizing: border-box;
    padding-top: 120px;
    padding-bottom: 120px;

    padding-left: ${px_par(500, 40)};

    ${mobileScreen(css`
      padding-top: 50px;
      padding-bottom: 45px;
      padding-left: unset;
    `)}

    h1 {
      text-align: left;
      margin-bottom: 20px;
    }

    p {
      &.calc {
        /* line-height: 2rem; */
      }
      img {
        vertical-align: middle;
      }

      input {
        width: 6rem;
        display: inline;
        margin-left: 0.5rem;
        margin-right: 0.5rem;
        margin-bottom: 0.5rem;
      }

      a {
        font-weight: ${fontWeights.bold};
        color: ${colors.offBlack};
      }

      .new-line-text {
        display: inline-block;
        /* margin-top: 0.5rem;
        display: block; */
      }
    }
    p + p {
      margin-top: 15px;
    }
  }
`
